(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('video-carousel')) return;

  // Load the YouTube IFrame API once, shared across all carousels on the page.
  function loadYouTubeAPI() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (window.__vcYouTubeReady) return window.__vcYouTubeReady;
    window.__vcYouTubeReady = new Promise(function (resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') { try { prev(); } catch (e) {} }
        resolve();
      };
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    });
    return window.__vcYouTubeReady;
  }

  function youTubeId(url) {
    if (!url) return null;
    var patterns = [
      /[?&]v=([\w-]{11})/,
      /youtu\.be\/([\w-]{11})/,
      /\/shorts\/([\w-]{11})/,
      /\/embed\/([\w-]{11})/,
      /\/live\/([\w-]{11})/,
    ];
    for (var i = 0; i < patterns.length; i++) {
      var m = url.match(patterns[i]);
      if (m) return m[1];
    }
    var bare = url.trim().match(/^([\w-]{11})$/);
    return bare ? bare[1] : null;
  }

  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vc-track]');
      this.muteBtn = this.querySelector('[data-vc-mute]');
      if (!this.track) return;

      // Build the playable items from each slide's URL; drop unparseable ones.
      this.slides = [];
      this.items = [];
      Array.from(this.querySelectorAll('[data-vc-slide]')).forEach((slide) => {
        const media = slide.querySelector('[data-vc-media]');
        const id = media ? youTubeId(media.dataset.vcUrl) : null;
        if (!media || !id) { slide.remove(); return; }
        media.style.backgroundImage = "url('https://i.ytimg.com/vi/" + id + "/hqdefault.jpg')";
        this.slides.push(slide);
        this.items.push({ id: id, host: slide.querySelector('[data-vc-player]'), player: null, ready: false });
      });
      if (!this.slides.length) { this.style.display = 'none'; return; }

      this.engaged = false;
      this.muted = true;
      this.inView = false;
      this.activeIndex = -1;
      this.targetIndex = undefined;
      this.attractTimer = null;
      this.attractEnabled = this.dataset.attract === 'true';
      this.attractSeconds = parseFloat(this.dataset.attractSeconds) || 3;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onScroll = this.onScroll.bind(this);
      this.onManualScroll = this.onManualScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('pointerdown', this.onManualScroll, { passive: true });
      this.track.addEventListener('wheel', this.onManualScroll, { passive: true });

      this.querySelector('[data-vc-prev]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-vc-next]').addEventListener('click', () => this.step(1));
      if (this.muteBtn) this.muteBtn.addEventListener('click', () => this.toggleMute());

      this.slides.forEach((slide, i) => {
        const media = slide.querySelector('[data-vc-media]');
        media.addEventListener('click', () => this.onTap(i));
        media.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onTap(i); }
        });
      });

      // Centre the middle slide so it is the enlarged one on load.
      this.initRaf = requestAnimationFrame(() => {
        this.centerSlide(Math.floor(this.slides.length / 2), 'auto');
        this.updateActive();
      });

      this.io = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) {
          if (!this.engaged) this.startAttract();
        } else {
          this.stopAttract();
          this.pauseAll();
          if (this.engaged && this.slides[this.activeIndex]) {
            this.slides[this.activeIndex].classList.add('is-paused');
          }
        }
      }, { threshold: 0.35 });
      this.io.observe(this);

      loadYouTubeAPI().then(() => this.createPlayers());
    }

    disconnectedCallback() {
      this.stopAttract();
      if (this.io) this.io.disconnect();
      if (this.track) {
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('pointerdown', this.onManualScroll);
        this.track.removeEventListener('wheel', this.onManualScroll);
      }
      if (this.initRaf) cancelAnimationFrame(this.initRaf);
      if (this.scrollRaf) { cancelAnimationFrame(this.scrollRaf); this.scrollRaf = null; }
      (this.items || []).forEach((it) => {
        if (it.player && it.player.destroy) { try { it.player.destroy(); } catch (e) {} }
      });
    }

    createPlayers() {
      if (!this.isConnected || !window.YT || !window.YT.Player) return;
      this.items.forEach((it) => {
        it.player = new window.YT.Player(it.host, {
          videoId: it.id,
          playerVars: {
            controls: 0, rel: 0, playsinline: 1, modestbranding: 1,
            disablekb: 1, fs: 0, iv_load_policy: 3, loop: 1, playlist: it.id, mute: 1,
          },
          events: {
            onReady: () => {
              it.ready = true;
              // Start the attract loop as soon as a player is usable and in view.
              if (this.inView && !this.engaged) this.startAttract();
            },
          },
        });
      });
    }

    // --- navigation -------------------------------------------------------
    step(dir) {
      const next = Math.min(this.slides.length - 1, Math.max(0, this.activeIndex + dir));
      this.muted = true; // arrow navigation focuses videos muted, never with sound
      this.centerSlide(next, 'smooth');
    }

    centerSlide(i, behavior) {
      const slide = this.slides[i];
      if (!slide) return;
      this.targetIndex = i;
      const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
      const scrollBehavior = this.reducedMotion ? 'auto' : (behavior || 'smooth');
      this.track.scrollTo({ left: left, behavior: scrollBehavior });
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.updateActive();
      });
    }

    onManualScroll() {
      this.targetIndex = undefined;
      this.muted = true; // a swipe/scroll focuses videos muted, never with sound
    }

    updateActive() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      this.slides.forEach((slide, i) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(slideCenter - center);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      if (best === this.activeIndex) return;
      this.activeIndex = best;
      this.slides.forEach((s, i) => s.classList.toggle('is-centered', i === best));
      this.updateArrows();
      // When engaged, the newly focused video plays — muted unless the focus
      // change came from a deliberate tap (which sets this.muted = false).
      // During a programmatic smooth scroll, only act once we reach the target.
      if (this.engaged && (this.targetIndex === undefined || best === this.targetIndex)) {
        this.targetIndex = undefined;
        this.playOnly(best, this.muted);
        this.syncMuteButton();
      }
    }

    updateArrows() {
      const prev = this.querySelector('[data-vc-prev]');
      const next = this.querySelector('[data-vc-next]');
      if (prev) prev.disabled = this.activeIndex <= 0;
      if (next) next.disabled = this.activeIndex >= this.slides.length - 1;
    }

    // --- playback ---------------------------------------------------------
    onTap(i) {
      const it = this.items[i];
      if (!it) return;
      if (!this.engaged) { this.engage(i); return; }
      if (i === this.activeIndex && it.playing) {
        this.pauseItem(it);
        this.slides[i].classList.add('is-paused');
        return;
      }
      // A deliberate tap is the only way to get sound.
      this.muted = false;
      if (i !== this.activeIndex) this.centerSlide(i, 'smooth');
      this.playOnly(i, false);
      this.syncMuteButton();
    }

    engage(i) {
      this.engaged = true;
      this.stopAttract();
      this.muted = false;
      if (this.muteBtn) this.muteBtn.hidden = false;
      this.centerSlide(i, 'smooth');
      this.playOnly(i, false);
      this.syncMuteButton();
    }

    playItem(it, muted) {
      if (!it || !it.ready || !it.player) return;
      try {
        if (muted) it.player.mute();
        else { it.player.unMute(); it.player.setVolume(100); }
        it.player.playVideo();
        it.playing = true;
      } catch (e) {}
    }

    pauseItem(it) {
      if (!it || !it.ready || !it.player) return;
      try { it.player.pauseVideo(); it.playing = false; } catch (e) {}
    }

    playOnly(i, muted) {
      this.items.forEach((it, idx) => {
        if (idx === i) {
          this.playItem(it, muted);
          this.slides[idx].classList.remove('is-paused');
        } else {
          this.pauseItem(it);
        }
      });
    }

    pauseAll() {
      this.items.forEach((it) => this.pauseItem(it));
    }

    toggleMute() {
      this.muted = !this.muted;
      const it = this.items[this.activeIndex];
      if (it && it.ready && it.player) {
        try {
          if (this.muted) it.player.mute();
          else { it.player.unMute(); it.player.setVolume(100); }
        } catch (e) {}
      }
      this.syncMuteButton();
    }

    syncMuteButton() {
      if (!this.muteBtn) return;
      this.muteBtn.setAttribute('aria-pressed', String(this.muted));
      const labelMute = this.dataset.labelMute || 'Mute video';
      const labelUnmute = this.dataset.labelUnmute || 'Unmute video';
      this.muteBtn.setAttribute('aria-label', this.muted ? labelUnmute : labelMute);
    }

    // --- attract loop -----------------------------------------------------
    startAttract() {
      if (!this.attractEnabled || this.engaged || this.reducedMotion) return;
      if (this.attractTimer) return;
      if (!this.items.length) return;

      // Begin from the slide nearest the centered (enlarged) one.
      const startReal = this.activeIndex >= 0
        ? this.activeIndex
        : Math.floor(this.slides.length / 2);
      let i = startReal;

      const stepAttract = () => {
        if (this.engaged) return;
        this.pauseAll();
        const idx = ((i % this.items.length) + this.items.length) % this.items.length;
        const it = this.items[idx];
        if (it && it.ready && it.player) {
          try { it.player.mute(); it.player.seekTo(0); it.player.playVideo(); it.playing = true; } catch (e) {}
        }
        this.attractTimer = setTimeout(() => {
          this.pauseItem(it);
          i += 1;
          stepAttract();
        }, this.attractSeconds * 1000);
      };
      stepAttract();
    }

    stopAttract() {
      if (this.attractTimer) {
        clearTimeout(this.attractTimer);
        this.attractTimer = null;
      }
    }
  }

  customElements.define('video-carousel', VideoCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
